import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ElementOverflowParentDirective } from './element-overflow-parent.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [ElementOverflowParentDirective],
    exports: [ElementOverflowParentDirective]
})
export class ElementOverflowParentModule { }
